import { MouseEventHandler } from "react"

import { twMerge } from "@lumen-energy/config-tailwind/twMerge"
import { RadioGroup } from "@lumen-energy/design-system"

import { LabelThemeColors } from "./LabelGroup"

export interface SelectLabelColorProps {
  handleSelectColor: MouseEventHandler
  selectedColor: LabelThemeColors
}

type SelectLabelColorDisplayProps = {
  [key in LabelThemeColors]: string
}

// TODO should non-theme colors be added to the theme?
export const radioItemDisplayColors: SelectLabelColorDisplayProps = {
  "accent-1": "bg-accent-1-500",
  "accent-2": "bg-brand-secondary-300",
  "accent-3": "bg-[#FCA31E]",
  primary: "bg-brand-primary-700",
  error: "bg-[#CE3030]",
  neutral: "bg-haze-700",
  success: "bg-[#14B68D]",
  secondary: "",
}

const radioItemDisplayText: SelectLabelColorDisplayProps = {
  "accent-1": "Light Blue",
  "accent-2": "Purple",
  "accent-3": "Yellow",
  primary: "Indigo",
  error: "Red",
  neutral: "Grey",
  success: "Green",
  secondary: "",
}

export function SelectLabelColor({
  handleSelectColor,
  selectedColor,
}: SelectLabelColorProps) {
  // All colors except "Secondary" and "Neutral" are currently used in UI
  const colorOrder = [
    LabelThemeColors.SUCCESS,
    LabelThemeColors.BRAND_PRIMARY,
    LabelThemeColors.ACCENT_1,
    LabelThemeColors.ACCENT_2,
    LabelThemeColors.ERROR,
    LabelThemeColors.ACCENT_3,
  ]

  // Increase the contrast of the highlight color when brand primary is selected
  const highlightColor = (selectedColor: LabelThemeColors) =>
    selectedColor === LabelThemeColors.BRAND_PRIMARY
      ? "border-brand-primary-300"
      : "border-brand-primary-500"

  return (
    <RadioGroup.Root
      id="themeColor"
      className="my-2 flex-row flex-nowrap place-content-between gap-0"
    >
      {colorOrder.map((color) => (
        <RadioGroup.ItemLabelOnly
          // Setting stroke ('color', 'stroke' attr) on Tabler Icon is not affecting the underlying path properties
          // Using a plain CSS shape and fully round border to highlight selection instead
          className={`box-content flex h-[18px] w-[18px] rounded-full border-2
              ${
                selectedColor === color
                  ? highlightColor(selectedColor)
                  : "border-transparent"
              }`}
          key={color}
          value={color}
          label={
            <div
              className={twMerge(
                "h-[18px] w-[18px] rounded-full",
                radioItemDisplayColors[color],
              )}
            ></div>
          }
          screenReaderText={`Select ${radioItemDisplayText[color]} color`}
          checked={selectedColor === color}
          onClick={(event) => handleSelectColor(event)}
        />
      ))}
    </RadioGroup.Root>
  )
}
